<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-card
      class="text-center py-2 form-menu-toolbar mt-0"
      id="form-menu-toolbar"
      max-width="50"
      :style="{
        transform: `translate(0, ${top}px`,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="addQuestion" class="mb-1" :disabled="!isUnPublished">
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>質問を追加</span>
      </v-tooltip>
      <!-- <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="addTitle" class="mb-1">
            <v-icon>mdi-format-size</v-icon>
          </v-btn>
        </template>
        <span>Add title and description</span>
      </v-tooltip> -->
      <!-- <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="addSection" class="mb-1">
            <v-icon>mdi-view-agenda-outline</v-icon>
          </v-btn>
        </template>
        <span>Add section</span>
      </v-tooltip> -->
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="moveQuestion" class="mb-1" :disabled="!isUnPublished">
            <v-icon>mdi-format-list-checkbox</v-icon>
          </v-btn>
        </template>
        <span>質問を並べ替え</span>
      </v-tooltip>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="reviewForm" class="mb-1" :disabled="!isUnPublished">
            <v-icon>mdi-cellphone-text</v-icon>
          </v-btn>
        </template>
        <span>プレビュー</span>
      </v-tooltip>
      <!-- <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="toggleCodeEditorModal(true)" class="mb-1">
            <v-icon>mdi-xml</v-icon>
          </v-btn>
        </template>
        <span>コード表示</span>
      </v-tooltip> -->
    </v-card>
    <MoveQuestionModal
      v-if="step1SurveyFormat"
      :visible="showMoveQuestionModal"
      :questions="step1SurveyFormat.surveySchema"
      @close="showMoveQuestionModal = false"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapMutations, mapState, mapGetters } from "vuex";
import MoveQuestionModal from "./MoveQuestionModal.vue";

import debounce from "lodash/debounce";
import {
  ADD_FORM_SCHEMA_ITEM,
  ADD_FORM_SCHEMA_SECTION,
  TOGGLE_CODE_EDITOR_MODAL,
  SET_ACTIVE_FORM_SCHEMA_ITEM,
} from "@/store/mutation-types";

export default Vue.extend({
  props: {},
  data() {
    return {
      top: 0,
      menuHeight: 0,
      lastScrollTop: 0,
      showMoveQuestionModal: false,
      scrollTarget: "#liff-preview",
      scrollOptions: {
        duration: 300,
        offset: 30,
        easing: "easeInOutCubic",
      },
    };
  },
  components: { MoveQuestionModal },
  computed: {
    ...mapState({
      activeItem: (state) => (state).formEditor.activeItem,
      isEditMode: (state) => (state).formEditor.isEditMode,
      isUnPublished: state => state.isUnPublished,
    }),
    ...mapGetters(["step1SurveyFormat"]),
  },
  watch: {
    activeItem(value) {
      if (value !== 0) {
        this.moveToolBar(value);
      }
    },
  },
  methods: {
    ...mapMutations({
      addQuestionToSection: ADD_FORM_SCHEMA_ITEM,
      addSectionToForm: ADD_FORM_SCHEMA_SECTION,
      toggleCodeEditorModal: TOGGLE_CODE_EDITOR_MODAL,
      setActiveItem: SET_ACTIVE_FORM_SCHEMA_ITEM,
    }),
    addQuestion() {
      this.addQuestionToSection();
    },
    moveQuestion() {
      this.setActiveItem(0);
      this.showMoveQuestionModal = true;
    },
    addSection() {
      this.addSectionToForm();
    },
    reviewForm() {
      this.setActiveItem(0);
    },
    moveToolBar(activeKey) {
      this.$nextTick(() => {
        var activeElement = document.getElementById(activeKey);
        var menu = document.getElementById("form-menu-toolbar");
        this.menuHeight = menu.offsetHeight;
        var topPosition = activeElement ? activeElement.offsetTop - menu.offsetTop : 0;

        console.log('topPosition', topPosition)
        this.top = topPosition;
      });
    },
    handleScroll() {
      // //Scroll down
      // if (window.scrollY > this.lastScrollTop && window.scrollY > this.top) {
      //   this.top = window.scrollY - this.menuHeight;
      // }
      // //Scroll up
      // else if (window.scrollY < this.top - this.menuHeight - 250) {
      //   this.top = window.scrollY + this.menuHeight + 250;
      // }
      // console.log('window.scrollY', window.scrollY)
      // this.lastScrollTop = window.scrollY;
    },
  },
  mounted() {
    this.moveToolBar(this.activeItem);
  },
  created() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener("scroll", this.handleDebouncedScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
});
</script>

<style lang="less">
.form-menu-toolbar {
  border-radius: 8px !important;
}
</style>
